import memoize from 'lodash/memoize'
import { Token } from '@pancakeswap/sdk'
import { ChainId,zeusChain } from '@pancakeswap/chains'
import { safeGetAddress } from 'utils'
import { isAddress } from 'viem'

const mapping = {
  [ChainId.BSC]: 'smartchain',
  [ChainId.ETHEREUM]: 'ethereum',
  [ChainId.POLYGON_ZKEVM]: 'polygonzkevm',
  [ChainId.ZKSYNC]: 'zksync',
  [ChainId.ARBITRUM_ONE]: 'arbitrum',
  [ChainId.LINEA]: 'linea',
  [ChainId.ZEUSCHAIN]: 'zeus',
  [ChainId.BASE]: 'base',
  [ChainId.POLYGON]: 'polygon',
  [ChainId.APOLLO]: 'apollo',
  [ChainId.APECHAIN]: 'ape',
}

const getTokenLogoURL = memoize(
  (token?: Token) => {


    if (token && mapping[token.chainId] && isAddress(token.address)) {
      return `https://tokens.zeusx.io/${mapping[token.chainId]}/${safeGetAddress(
        token.address,
      )}.png`;
    }

    return null;
  },
  (t) => `${t?.chainId}#${t?.address}`,
);


export const getTokenLogoURLByAddress = memoize(
  (address?: string, chainId?: number) => {
    if (address && chainId && mapping[chainId] && isAddress(address)) {
      return `https://assets-cdn.trustwallet.com/blockchains/${mapping[chainId]}/assets/${safeGetAddress(
        address,
      )}/logo.png`
    }
    return null
  },
  (address, chainId) => `${chainId}#${address}`,
)

export default getTokenLogoURL
